import React from 'react';

export const loadingElement = <div style={{ height: `100%` }} />;
export const containerElement = (
  <div id="map" style={{ width: '100%', marginLeft: 0 }} role="region" aria-label="Google Map"/>
);
export const mapElement = <div style={{ height: `100%` }} />;
